import { AuthenticationEffects } from '@modules/auth/authentication-effects';
import { CompanyProfileEffects } from '@modules/company-profile/store/company-profile.effects';
import { NotificationTemplateEffects } from './store/notification/notification-template.effects';
import { OmcRegistrationEffects } from '@modules/registration/omc-registration/store/omc-registration.effects';
import { SupplierRegistrationEffects } from '@modules/registration/supplier-registration/store/supplier-registration.effects';
import { SupplierDashboardEffects } from '@modules/external-services/supplier-management/store/supplier-dashboard.effects';
import { AttachmentTypeEffects } from './store/attachment-types/attachment-types.effects';

import { RegistrationAttachmentTypeEffects } from './store/registration-attachment-types/registration-attachment-types.effects';
import { RegistrationEffects } from '@modules/registration/store/registration.effects';
import { CompanyManagementEffects } from '@modules/external-services/company-management/store/company-management.effects';
import { WorkflowEffects } from '@modules/workflow/store/workflow.effects';
import { FinanceManagementEffects } from '@modules/external-services/finance-management/store/finance-management.effects';
import { BankDetailsEffects } from './store/bank-details/bank-details.effects';
import { FinancialSecurityConfigurationEffects } from '@modules/financial-security-configuration/store/financial-security-configuration.effects';
import { ProductUsageEffects } from '@modules/products/store/product-usage.effects';
import { ProductEffects } from '@modules/products/store/product.effects';
import { ProductCategoryEffects } from '@modules/products/store/product-category.effects';
import { TerminalRegistrationEffects } from '@modules/registration/terminal-registration/store/terminal-registration.effects';
import { FinancialYearEffects } from './store/financial-year/financial-year.effects';
import { PortsEffects } from './store/ports/ports.effects';
import { DemandCyclesEffects } from './store/demand-cycles/demand-cycles.effects';
import { TerminalOperatorsEffects } from '@modules/terminal-operators/store/terminal-operators.effects';
import { TerminalOperatorManagementEffects } from '@modules/external-services/terminal-operator-management/store/terminal-operator-management.effects';
import { OmcManagementEffects } from '@modules/external-services/omc-management/store/omc-management.effects';
import { ExternalAuthEffects } from './layouts/external-authenticated-layout/store/external-auth.effects';
import { ReferenceDataEffects } from '@modules/planning/store/reference-data.effects';
import { NonBpsRegistrationEffects } from '@modules/registration/non-bps-registration/store/non-bps-registration.effects';
import { NonBpsManagementEffects } from '@modules/external-services/non-bps-management/store/non-bps-management.effects';
import { ConsigneesEffects } from './store/consignees/consignees.effects';
import { SmartForecastingEffects } from '@modules/smart-forecasting/store/smart-forecasting.effects';
import { TankersLineUpEffects } from '@modules/external-services/reports/store/tankers-line-up.effects';

export const effects: any[] = [
  AuthenticationEffects,
  CompanyProfileEffects,
  NotificationTemplateEffects,
  OmcRegistrationEffects,
  SupplierRegistrationEffects,
  SupplierDashboardEffects,
  AttachmentTypeEffects,
  RegistrationAttachmentTypeEffects,
  RegistrationEffects,
  CompanyManagementEffects,
  FinanceManagementEffects,
  WorkflowEffects,
  BankDetailsEffects,
  FinancialSecurityConfigurationEffects,
  ProductUsageEffects,
  ProductEffects,
  ProductCategoryEffects,
  TerminalRegistrationEffects,
  FinancialYearEffects,
  PortsEffects,
  DemandCyclesEffects,
  TerminalOperatorsEffects,
  TerminalOperatorManagementEffects,
  OmcManagementEffects,
  ExternalAuthEffects,
  ReferenceDataEffects,
  NonBpsRegistrationEffects,
  NonBpsManagementEffects,
  ConsigneesEffects,
  SmartForecastingEffects,
  TankersLineUpEffects,
];
